let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3EMmo")).then(() => parcelRequire('jPybt'));